import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { Router } from "@angular/router";
import { ACCOUNTS_URL, REST_API_REQUEST_CALL_URL, Util } from "../utils/index";
import { AlertService } from "./index";
import { ApiService } from "../services/api.service";

@Injectable()
export class CfsService {
  constructor(
    private http: Http,
    private router: Router,
    private alertService: AlertService,
    private apiService: ApiService
  ) {}

  getCfsList(): Observable<any> {
    return this.apiService.get(REST_API_REQUEST_CALL_URL.GET_CFS_LIST_URL);
  }

  getCfsListForAdmin(): Observable<any> {
    return this.apiService.get(
      REST_API_REQUEST_CALL_URL.GET_ADMIN_CFS_LIST_URL
    );
  }

  postCfs(params): Observable<any> {
    return this.apiService
      .post(REST_API_REQUEST_CALL_URL.GET_ADMIN_CFS_LIST_URL, params, true)
      .map((res) => {
        if (res.result) {
          this.alertService.success("저장되었습니다.");
          return res.result;
        } else {
          if (res.errorCode == "204") {
            // this.authService.logout();

            this.apiService.redirectAccountLogin();
          } else {
            this.alertService.error(res.errorMsg);
            return null;
          }
        }
      });
  }

  delCfs(params): Observable<any> {
    return this.apiService
      .post(REST_API_REQUEST_CALL_URL.GET_ADMIN_CFS_LIST_URL + "/" + params)
      .map((res) => {
        if (res.result) {
          this.alertService.success("삭제되었습니다.");
          return res.result;
        } else {
          if (res.errorCode == "204") {
            // this.authService.logout();

            this.apiService.redirectAccountLogin();
          } else {
            this.alertService.error(res.errorMsg);
            return null;
          }
        }
      });
  }
}

export class CfsModel {
  cfsId: number;
  corpId: number;
  cfsName: string;
  person: string;
  position: string;
  customs: string;
  tel: string;
  mobile: string;
  fax: string;
  zip: string;
  address: string;
  addressDtl: string;
  code: string;
  delYn: number;
}

export class CfsModel2 {
  isChecked: boolean;
  cfsId: number;
  corpId: number;
  cfsName: string;
  person: string;
  position: string;
  customs: string;
  tel: string;
  mobile: string;
  fax: string;
  zip: string;
  address: string;
  addressDtl: string;
  code: string;
}



// WEBPACK FOOTER //
// ./src/app/services/cfs.service.ts